
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/move-your-sport",
      function () {
        return require("private-next-pages/move-your-sport/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/move-your-sport"])
      });
    }
  